import React from 'react'
import PropTypes from 'prop-types'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { EVENT_FORM_MODE } from 'components/Events/EventForm/EventForm'
import { withRouter } from 'react-router-dom'
import { wrapEvent } from 'lib/utils/store/wrappers/event/Event'
import { getEventModalUrl, REMINDER_EVENT_TYPES } from 'lib/utils/store/event'

import ContextMenuContainer from 'components/Navigation/ContextMenu/ContextMenuContainer/ContextMenuContainer'
import EventsNavMenuItem from 'components/Navigation/EventsNav/EventsNavMenu/EventsNavMenuItem/EventsNavMenuItem'

import './event-reminder-select-list.css'

const EventReminderSelectList = ({ t, history, location, vehicleId }) => {
    const openEventsModal = (eventType) => {
        history.push(getEventModalUrl(location, EVENT_FORM_MODE.CREATE_REMINDER, vehicleId, eventType))
    }

    return (
        <ContextMenuContainer className="event-reminder-select-list" disableBackdrop>
            {REMINDER_EVENT_TYPES.map(eventType => (
                <EventsNavMenuItem
                    key={eventType}
                    onSelect={() => openEventsModal(eventType)}
                    trackName={`${eventType}Event`}
                    wrappedEvent={wrapEvent({ type: eventType })}
                >
                    {t(`events:${eventType}.title`)}
                </EventsNavMenuItem>
            ))}
        </ContextMenuContainer>
    )
}

EventReminderSelectList.propTypes = {
    vehicleId: PropTypes.string.isRequired,
}

export default flowRight(
    withErrorBoundaryNoRender,
    withTranslationCustom(['events']),
    withRouter,
)(EventReminderSelectList)
